import { StyleSheet, View } from 'react-native';

import Text from '@/components/Text';
import { i18n } from '@/utils/i18n';

interface TabBarLabelProps {
  focused: boolean;
  side: 'left' | 'right';
  text: string;
}

function TabBarLabel({ focused, side, text }: TabBarLabelProps) {
  return (
    <View style={side === 'left' ? styles.leftTabBarLabel : styles.rightTabBarLabel}>
      <View
        style={{
          alignItems: 'center',
          backgroundColor: focused ? 'black' : 'transparent',
          width: 144,
          borderRadius: 20,
          height: 34,
          justifyContent: 'center'
        }}>
        <Text fontWeight={focused ? '900' : '450'} style={{ color: focused ? 'white' : 'black', fontSize: 14 }}>
          {i18n.t(text)}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  leftTabBarLabel: {
    borderWidth: 1,
    borderRightWidth: 0,
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    borderColor: '#D5D5D5',
    overflow: 'hidden'
  },

  rightTabBarLabel: {
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    borderColor: '#D5D5D5',
    overflow: 'hidden'
  }
});

export default TabBarLabel;
